export default "__VITE_ASSET__DUoYcJo4__"